import { PresetChartType } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/const';
import { IFrame } from '../property/frame/frame.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import ChartModel from './chart-model';
import { ChartModelFactory } from './chart-presets/chart-model-factory';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { UIModelType } from '../constant';
import { ISlideModel } from '../Interface/slide-model.interface';
import { DataType } from '@tencent/slide-sdk-model';
import { canvasToEmu } from '@src/slide/infrastructure/module/independent/unit';
import { IChartModel } from '../Interface/chart-v3/chart-model.interface';

export interface ChartOptions {
    titleText?: string;
    showLegend?: boolean;
    showDataLabels?: boolean;
    chartData?: ChartData;
}

interface ChartData {
    // 类别名[]
    categories: string[],
    // 系列名[] 默认为 系列1,系列2...
    seriesNames?: string[],
    // 系列数 * 类别数  [[类别1],[类别2]...][]
    values: number[][],
}

export function insertChart(
    slideModel: ISlideModel,
    type: PresetChartType,
    frame: IFrame,
    options: ChartOptions = { showLegend: true, showDataLabels: false },
) {
    const chartProps = getChartProps(options);
    const seriesProps = {
        valuesPreset: options?.chartData?.values,
        categoriesPreset: options?.chartData?.categories,
        seriesNamesPreset: options?.chartData?.seriesNames,
        showDataLabels: options.showDataLabels,
    };
    const chartUiData = ChartModelFactory.createChartDataByType(type, chartProps, seriesProps, options.titleText);
    const chartSdkData: any = {};
    ChartModel.convertDataUiToSdk(chartUiData, chartSdkData, {});
    slideModel.addElement(UIModelType.CHART, {
        ...chartSdkData,
        spPr: {
            xfrm: {
                ext: {
                    cx: canvasToEmu(frame.width),
                    cy: canvasToEmu(frame.height),
                },
                off: {
                    x: canvasToEmu(frame.left),
                    y: canvasToEmu(frame.top),
                },
            },
        },
        type: DataType.GraphicalObjectFrameChart,
    });
}

function getChartProps(options?: ChartOptions) {
    const props: Partial<IChartModel> = {};
    if (!options?.titleText) {
        props.title = null;
    }
    if (options?.showLegend === false) {
        props.legend = null;
    }

    return props;
}

const DEFAULT_CHART_SERIES_PRESET = ['系列a', '系列b', '系列c'];
const DEFAULT_CHART_SERIES_CATEGORIES_PRESET = ['类别 1', '类别 2', '类别 3', '类别 4'];
const DEFAULT_CHART_VALUES_PRESET = [
    [4.3, 2.5, 3.5, 4.5],
    [2.4, 4.4, 1.8, 2.8],
    [2, 2, 3, 5],
];

export function testInsertChart(
    chartType = PresetChartType.COLUMN_CLUSTERED,
    series = DEFAULT_CHART_SERIES_PRESET,
    categories = DEFAULT_CHART_SERIES_CATEGORIES_PRESET,
    values = DEFAULT_CHART_VALUES_PRESET,
    chartOptions?: ChartOptions,
) {
    function getAppService(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }

    function getSelectionService(): ISelectionService {
        return getAppService()?.viewableServiceLayer.selectionService;
    }

    const chartFrame =  { width: 500, height: 500, left: 300, top: 300 };
    const options = {
        chartData: {
            categories,
            values,
            seriesNames: series,
        },
        showTitle: true,
        showLegend: true,
        showDataLabels: true,
        titleText: 'chart title',
        ...chartOptions,
    };
    const { currentSlideIndex } = getSelectionService();
    const slideModel = getSelectionService().slides[currentSlideIndex];
    insertChart(slideModel, chartType, chartFrame, options);
}
